import Container from "components/layout/Container";
import Main from "components/layout/Main";
import VendorNav from "components/layout/VendorNav";
import VendorSidebar from "components/layout/VendorSidebar";
import { PINInput } from "components/misc";
import VButton from "components/ui/VButton";
import useAsync from "hooks/useAsync";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { vendorRoutes } from "routes/routes";
import { showDanger, showSuccess } from "utilities/misc";
import { patch } from "utilities/network";

const ChangePIN: React.FC = () => {
  const navigate = useNavigate();
  const [oldPassword, setOldPassword] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const {
    execute: changePassword,
    status,
    value,
  } = useAsync(
    () =>
      patch(`vendor/profile/changePIN`, {
        currentPIN: oldPassword,
        newPIN: password,
        confirmPIN: confirmPassword,
      }),
    false
  );

  const handleSubmit = () => {
    if (oldPassword.length !== 4) {
      return showDanger("Old password should be 4 characters long");
    }
    if (password.length !== 4) {
      return showDanger("Password should be 4 characters long");
    }
    if (password !== confirmPassword) {
      return showDanger("Passwords do not match");
    }

    changePassword();
  };

  useEffect(() => {
    if (value?.data?.data?.success) {
      showSuccess(value?.data?.message || "Password changed successfully");
      navigate(vendorRoutes.profile);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  return (
    <Container isVendor>
      <VendorSidebar />

      <Main isVendor>
        <VendorNav title="Change PIN" />

        <div className="mt-10">
          <PINInput
            pin={oldPassword}
            placeholder=""
            label="Enter current pin"
            setPin={setOldPassword}
            type="password"
            boxLength={4}
          />

          <PINInput
            pin={password}
            placeholder=""
            label="Enter new pin"
            setPin={setPassword}
            type="password"
            boxLength={4}
          />

          <PINInput
            pin={confirmPassword}
            placeholder=""
            label="Confirm new pin"
            setPin={setConfirmPassword}
            type="password"
            boxLength={4}
          />

          <VButton
            onClick={handleSubmit}
            status={status}
            className="bg-orange-300 py-4 mt-10 text-white w-full"
          >
            Change PIN
          </VButton>
        </div>
      </Main>
    </Container>
  );
};

export default ChangePIN;
